<div class="dasboard-width">
    <div class="row header mar-lft-rgt-0">
  
      <div class="col-md-3">CIT Hybrid Report</div>
  
  
      <div class="col-md-3">
        <ol class="breadcrumb cust-bread">
          <li class="breadcrumb-item"><a class="pointer" (click)="changeRouting()"><i
                  class="fa fa-dashboard"></i> Home</a></li>
          <li class="breadcrumb-item active" aria-current="page">CIT Hybrid Report</li>
        </ol>
      </div>
    </div>
  
    <div class="row mar-lft-rgt-0 filter">
      <div class="col-sm-12">
        <mat-form-field>
          <mat-label>Ticket Type:</mat-label>
          <mat-select [(ngModel)]="ticketTypeSelected" (selectionChange)="onSelectTicketType($event.value)" class="matSize">
            <mat-option *ngFor="let button of types; let i = index;" [value]="i" class="matSize"
            >{{button.name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  
    <div class="row mar-lft-rgt-0 filter">
      <div class="col-md-12">
        <select class="custom-select  tcktyp" *ngFor="let ticket of allTicketTypes;"
                (change)="onCategoryChange(ticket,$event.target.value)" id="ticket_{{ticket.id}}"
                [disabled]="ticket.isDisabled">
          <option *ngFor="let option of ticket.options" [value]="option|json">{{option.title}}</option>
        </select>
      </div>
    </div>
  
    <div class="row mar-lft-rgt-0 filter">
      <div class="col-sm-3">
        <mat-form-field>
          <mat-label>Search By:</mat-label>
          <mat-select [(ngModel)]="selectedDateType" class="matSize" (selectionChange)="onSelectDateType($event.value)">
            <mat-option *ngFor="let date of dateType" [value]="date.id" class="matSize">{{date.name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-sm-3" [hidden]="hideDate">
        <input [owlDateTimeTrigger]="dt1" [owlDateTime]="dt1" class="form-control radius-0 font-13"
               [(ngModel)]="fromDate" placeholder='From date'>
        <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
      </div>
      <div class="col-sm-3" [hidden]="hideDate">
        <input [owlDateTimeTrigger]="dt2" [owlDateTime]="dt2" class="form-control radius-0 font-13"
               [(ngModel)]="toDate" placeholder='To date'>
        <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
      </div>
    </div>
  
    <div class="row mar-lft-rgt-0">
      <div class="col-sm-3">
        <mat-form-field>
          <mat-label>Status:</mat-label>
          <mat-select [(ngModel)]="statusSelected" [formControl]="allStatusSelected" class="matSize" multiple>
            <mat-option [value]="-1" (click)="selectAllStatus(ev , allStatus)" class="matSize" #ev>SelectAll</mat-option>
            <mat-option *ngFor="let status of allStatus" [value]="status.id" class="matSize"
            >{{status.status}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-sm-3">
        <div class="md-form">
          <mat-form-field>
            <mat-label>Priority:</mat-label>
            <mat-select [(ngModel)]="prioritySelected" [formControl]="allPrioritySelected" class="matSize" multiple>
              <mat-option [value]="-1" (click)="selectAllPriority(ev1 , priorities)" class="matSize" #ev1>SelectAll</mat-option>
              <mat-option *ngFor="let priority of priorities" [value]="priority.id" class="matSize"
              >{{priority.name}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="col-sm-2">
        <!--<mat-form-field>-->
          <!--<mat-label>Escalation Level:</mat-label>-->
          <!--<mat-select [(ngModel)]="userGroupSelected" [formControl]="allGroupSelected" class="matSize" multiple>-->
            <!--<mat-option [value]="-1" (click)="selectAllGroup(ev2 , userGroups)" class="matSize" #ev2>SelectAll</mat-option>-->
            <!--<mat-option *ngFor="let group of userGroups" [value]="group.groupId" class="matSize"-->
            <!--&gt;{{group.grpName}}</mat-option>-->
          <!--</mat-select>-->
        <!--</mat-form-field>-->
      </div>
      <div class="col-sm-2">
        <button class="btn btn-success addButton font-13 sub-btn" (click)="generate()">Generate Report</button>
      </div>
      <div class="col-sm-2">
        <button class="btn btn-success addButton font-13 download-btn" (click)="getReportList()">Refresh Page</button>
      </div>
    </div>
  
  
  
    <div class="col-md-12 padtop">
      <div class="card reportdiv">
        <div class="card-header row">
          <div class="loader" [hidden]="reportLoaded"><img class="loading-gif" src="../../../assets/img/loader.gif"></div>
          <table class="table table-striped">
            <thead>
            <tr>
              <th scope="col">Report File Name</th>
              <th scope="col">Report Generated Date</th>
              <th scope="col">From Date</th>
              <th scope="col">To Date</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let file of reportFiles">
              <td><a class="pointer" (click)="downloadFile(file.document_nm)">{{file.document_nm}}</a></td>
              <td>{{file.createdate}}</td>
              <td>{{file.fromdt}}</td>
              <td>{{file.todt}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <notifier-container></notifier-container>